import { autoType, index } from "d3";
import React, { useReducer, useEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { Icon, Radio } from "semantic-ui-react";
import "./Tour.scss";
// import InteractiveIcon from "../../../assets/svg/interactive-help-icon.svg";
import dashboardIcon from "../../../assets/svg/dashboardWhite.svg";
// import { handleInputChange } from "react-select/src/utils";

const TOUR_STEPS = [
    {
        target: ".profile_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={dashboardIcon} className="tour_image_left"></img> <span className="tour_header">Profile</span>
                    <span className="tour_stepCount">1/3</span>
                </div>
                <p className="tour_content">All your profile information is here. You can also reset your password and change your timezone.</p>
            </div>
        ),
        // placement: "center",
        disableBeacon: true,
    },
    {
        target: ".profile_step2",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={dashboardIcon} className="tour_image_left"></img> <span className="tour_header">Edit Profile</span>
                    <span className="tour_stepCount">2/3</span>
                </div>
                <p className="tour_content">
                    You can edit your profile details by clicking here. Please contact support if you would like to change your email id.
                </p>
            </div>
        ),
        placement: "top",
    },
    {
        target: ".profile_step3",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={dashboardIcon} className="tour_image_left"></img> <span className="tour_header">Switch Company</span>
                    <span className="tour_stepCount">3/3</span>
                </div>
                <p className="tour_content">
                    {`If you have access to multiple companies, you will see this button "Switch Company".  You can click here to switch to another company.`}
                </p>
            </div>
        ),
    },
];

const INITIAL_STATE = {
    key: new Date(), // This field makes the tour to re-render when we restart the tour
    run: false,
    continuous: true,
    loading: false,
    stepIndex: 0,
    steps: TOUR_STEPS,
    checked: true,
};

// Reducer will manage updating the local state
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "START":
            return { ...state, run: true };
        case "RESET":
            return { ...state, stepIndex: 0 };
        case "STOP":
            return { ...state, run: false };
        case "NEXT_OR_PREV":
            return { ...state, ...action.payload };
        case "RESTART":
            return {
                ...state,
                stepIndex: 0,
                run: true,
                loading: false,
                key: new Date(),
            };
        default:
            return state;
    }
};

// Tour component
const Tour_profile = () => {
    // console.log('loca',this.props.location)
    // Tour state is the state which control the JoyRide component
    const [tourState, dispatch] = useReducer(reducer, INITIAL_STATE);

    useEffect(() => {
        // Auto start the tour if the tour is not viewed before
        if (!localStorage.getItem("tour")) {
            dispatch({ type: "START" });
        }
    }, []);

    // Set once tour is viewed, skipped or closed
    const setTourViewed = () => {
        // localStorage.setItem("tour", "1");
    };

    const callback = (data) => {
        const { action, index, type, status } = data;

        if (
            // If close button clicked, then close the tour
            action === ACTIONS.CLOSE ||
            // If skipped or end tour, then close the tour
            (status === STATUS.SKIPPED && tourState.run) ||
            status === STATUS.FINISHED
        ) {
            setTourViewed();
            dispatch({ type: "STOP" });
        } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
            // Check whether next or back button click and update the step.
            dispatch({
                type: "NEXT_OR_PREV",
                payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
            });
        }
    };

    const startTour = () => {
        // Start the tour manually
        dispatch({ type: "RESTART" });
    };

    return (
        <>
            {/* <div className="tour_toggle">
                <img src={InteractiveIcon} title="Interactive Help" className="tour-start items-center tour-link" color="blue" onClick={startTour} />
            </div> */}
            <JoyRide
                {...tourState}
                callback={callback}
                scrollToSteps={false}
                disableScrolling={true}
                // showSkipButton={true}
                styles={{
                    options: {
                        arrowColor: tourState.stepIndex == 1 ? "#fff" : "#268af6",
                        padding: 0,
                        margin: 0,
                    },
                    spotlight: {
                        outline: "2px white",
                        outlineStyle: "dashed",
                        outlineOffset: tourState.stepIndex == 0 ? "-3px" : "2px",
                        zIndex: 4000,
                    },
                    tooltipContainer: {
                        textAlign: "left",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        padding: "0px",
                        backgroundColor: "#268af6",
                        borderRadius: "20px",
                    },
                    buttonBack: {
                        backgroundColor: "rgb(239, 241, 245)",
                        color: "#000000",
                        borderRadius: "4px",
                        marginRight: "15%",
                        height: "36px",
                        minWidth: "84px",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                    },
                    buttonNext: {
                        backgroundColor: "#268af6",
                        marginRight: tourState.stepIndex == 0 ? "40%" : "20%",
                        height: "36px",
                        minWidth: "84px",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        outline: "0px",
                    },
                    buttonClose: {
                        color: "#ffffff",
                        height: "12px",
                        width: "12px",
                        top: "-5px",
                    },
                }}
                locale={{
                    last: "Done",
                    back: "Previous",
                }}
            />
        </>
    );
};

export default Tour_profile;
